import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { FC, useContext } from "react";
import { useTranslation } from "react-i18next";

import { ExpandedTable } from "@ryde/controls";

import { BulkPreviewStepUploadConflictsContext } from "../../bulk-preview-step-upload-conflicts.context";
import { RejectedBookingUploadExpanded } from "./rejected-bookings-upload-expanded";

export const RejectedBookingsUploadSimple: FC = () => {
  const { conflicts } = useContext(BulkPreviewStepUploadConflictsContext);
  const { t } = useTranslation();

  return (
    <RejectedBookingUploadExpanded>
      <ExpandedTable dataE2E="rejected-bookings-upload-table">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>{t("general.index")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {conflicts?.map(conflictRow => (
              <TableRow key={conflictRow.index}>
                <TableCell>{conflictRow.index}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </ExpandedTable>
    </RejectedBookingUploadExpanded>
  );
};
